// extracted by mini-css-extract-plugin
export default {"criteriaTag":"CriteriaTag_criteriaTag__haGSe","selected":"CriteriaTag_selected__PYFTM","clickable":"CriteriaTag_clickable__s+Gwt"};